import type { CustomEventsContext } from '../types'

export default function (this: CustomEventsContext, imageUrl: string, text: string, target = 'other') {
  return this.sendEventWithCallback('digitalFlyers.share', { image_url: imageUrl, text, target })
    .then((data: unknown) => {
      const d = data as { shared?: boolean }
      if (d.shared === true) {
        return
      }
      return Promise.reject(
        new Error(this.ERROR_UNKNOWN)
      )
    })
}
